let searchClosebtn = document.querySelector(".search-close-btn a");
let searchOpenbtn = document.getElementById("header_search_btn");
let headerSearchContainer = document.querySelector(".header-search-container");
let searchClearBtn = document.querySelector(".search-clear button");
let predictiveSearch = document.getElementById("predictive-search");
let desktopSearchOpen = document.querySelector("button.desktop-search-icon");
let desktopSearchClose = document.querySelector(".search-close-desktop");

//open search bar mobile & background scroll off
searchOpenbtn.addEventListener("click",function(){
    headerSearchContainer.classList.remove("hide");
    document.body.classList.add("scroll_lock");
});

//open desktop bar mobile & background scroll off
desktopSearchOpen.addEventListener("click", function(){
    headerSearchContainer.classList.remove("hide");
    document.querySelector(".header-search-input").focus();
    document.body.classList.add("scroll_lock");
});

//close search bar & background scroll on
searchClosebtn.addEventListener("click",function(e){
    headerSearchContainer.classList.add("hide");

    if(checkBoostOverflow){
        document.body.classList.remove("boost-pfs-search-suggestion-mobile-open");
    }
    document.body.classList.remove("scroll_lock");
    clearSearch();
});

// clear search input and close predictive div
searchClearBtn.addEventListener("click", function(e){
    e.preventDefault();
    this.classList.add("hide");
    clearSearch();
});

// close desktop search bar
desktopSearchClose.addEventListener("click",function(e){
    e.preventDefault();
    headerSearchContainer.classList.add("hide");
    document.body.classList.remove("scroll_lock");
    clearSearch();
});

//boost body overflow checking
let checkBoostOverflow = function(){
    if(document.body.classList.contains("boost-pfs-search-suggestion-mobile-open")){
        return true;
    }else {
        return false;
    }
}

//clear input & hide predictive search
function clearSearch(){
    document.querySelector(".header-search-input").value = "";
    predictiveSearch.style.display = "none";
    searchClearBtn.classList.add("hide");
}

let predictiveSearchInput = document.querySelector(".header-search-input");

// predictiveSearchInput.addEventListener("keyup", function (e) {
//     debugger;
//     console.log("keycode",e.keyCode);
//     if (e.keyCode == 13) {
//         console.log("working")
//     }
// });